{
  "language": {
    "name": "Tiếng Việt",
    "title": "Ngôn ngữ"
  },
  "format": {
    "currency": "{{value, currency(currency: USD)}}",
    "number": "{{value, number(maximumFractionDigits: 9)}}"
  },
  "button": {
    "auto": "Tự động",
    "bridge": "Cầu",
    "buy": "Mua",
    "buyNow": "Mua ngay bây giờ",
    "cancel": "Huỷ bỏ",
    "connectWallet": "Kết nối ví",
    "contactSupport": "Liên hệ hỗ trợ",
    "continue": "Tiếp tục",
    "copyAddress": "Sao chép địa chỉ",
    "dark": "Tối",
    "delete": "Xóa",
    "disconnect": "Ngắt kết nối",
    "done": "Hoàn thành",
    "exchange": "Hoán đổi",
    "getGas": "Thiết lập gas",
    "hide": "Ẩn",
    "learnMore": "Xem thêm",
    "lifiCheckout": "LI.FI Checkout",
    "lifiExchange": "LI.FI Exchange",
    "light": "Sáng",
    "max": "Tối đa",
    "ok": "Ok",
    "removeTransaction": "Xoá giao dịch",
    "reset": "Đặt lại",
    "resetSettings": "Đặt lại cài đặt",
    "reviewBridge": "Xem xét cầu",
    "reviewPurchase": "Đánh giá thanh toán",
    "reviewSwap": "Xem lại Swap",
    "seeDetails": "Xem chi tiết",
    "showAll": "Hiển thị tất cả",
    "startBridging": "Bắt đầu đi cầu",
    "startSwapping": "Bắt đầu Swap",
    "swap": "Swap",
    "tryAgain": "Thử lại",
    "viewCoverage": "Xem phạm vi bảo hiểm",
    "viewOnExplorer": "Xem tại Explorer"
  },
  "header": {
    "activeTransactions": "Các giao dịch hiện tại",
    "bridge": "Cầu",
    "checkout": "Thanh toán",
    "exchange": "Hoán đổi",
    "from": "Swap từ",
    "gas": "Gas",
    "payWith": "Thanh toán bằng",
    "purchase": "Thanh toán",
    "purchaseDetails": "Thông tin chi tiết",
    "selectChain": "Chọn chain",
    "selectWallet": "Chọn ví",
    "settings": "Cài đặt",
    "swap": "Swap",
    "to": "Swap từ",
    "transactionDetails": "Chi tiết giao dịch",
    "transactionHistory": "Lịch sử giao dịch",
    "walletConnected": "Wallet connected",
    "youGet": "Bạn nhận"
  },
  "info": {
    "message": {
      "autoRefuel": "Gas trên {{chainName}} chain của bạn đang thấp. Để tiếp tục, bạn nên có thêm gas để hoàn thành việc swap.",
      "emptyActiveTransactions": "Các lệnh swap đang xử lý sẽ được hiện ở đây. Khi nào lệnh hoàn tất, bạn có thể kiểm tra lại tại mục lịch sử swap.",
      "emptyTokenList": "Chúng tôi không thể tìm được token ở {{chainName}} hoặc số dư của bạn không có. Vui lòng thử tìm kiếm lại hoặc chọn một chain khác.",
      "emptyTransactionHistory": "Lịch sử Swap chỉ được lưu trữ cục bộ và sẽ bị xóa nếu bạn xóa dữ liệu trình duyệt của mình.",
      "routeNotFound": "Lý do cho điều đó có thể là: tính thanh khoản thấp, số tiền được chọn quá thấp, chi phí gas quá cao hoặc không có lộ trình cho cặp giao dịch đã chọn."
    },
    "title": {
      "autoRefuel": "Thiết lập Gas",
      "emptyActiveTransactions": "Không có thông tin giao dịch hiện tại",
      "emptyTransactionHistory": "Chưa có giao dịch",
      "routeNotFound": "Không có đường đi"
    }
  },
  "success": {
    "message": {
      "exchangePartiallySuccessful": "Chúng tôi đã cố gắng hoàn thành việc hoán đổi, nhưng {{tool}} đã cạn thanh khoản cho token {{tokenSymbol}}.",
      "exchangeSuccessful": "Hiện tại {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} trong ví {{walletAddress}} tại {{chainName}} chain.",
      "purchaseSuccessful": "Hiện tại bạn đang nắm giữ {{assetName}} tại ví {{walletAddress}} trên chain {{chainName}}."
    },
    "title": {
      "bridgePartiallySuccessful": "Swap thành công một phần",
      "bridgeSuccessful": "Bridge thành công",
      "purchaseSuccessful": "Mua thành công",
      "refundIssued": "Đã Refund",
      "swapPartiallySuccessful": "Swap thành công một phần",
      "swapSuccessful": "Swap thành công"
    }
  },
  "warning": {
    "message": {
      "deleteActiveTransactions": "Các giao dịch đang hoạt động chỉ được lưu trữ cục bộ và không thể phục hồi nếu bạn xóa chúng.",
      "deleteTransactionHistory": "Lịch sử Swap chỉ lưu trữ cục bộ và không thể phục hồi khi bạn xoá chúng.",
      "highValueLoss": "Giá trị của token nhận được đang thấp hơn rất nhiều so với token được swap và chi phí giao dịch.",
      "insufficientFunds": "Bạn không có đủ tiền để thực hiện tác vụ này.",
      "insufficientGas": "Bạn không đủ gas để thực hiện swap. Bạn cần thêm ít nhất:",
      "rateChanged": "Tỉ lệ hoán đổi đã thay đổi. Để tiếp tục Swap, bạn sẽ chấp nhận tỉ lệ mới.",
      "resetSettings": "Thao tác này sẽ đặt lại mức độ ưu tiên của tuyến đường, độ trượt giá, giá gas, bridge và sàn giao dịch."
    },
    "title": {
      "deleteActiveTransactions": "Xóa tất cả giao dịch đang thực hiện?",
      "deleteTransaction": "Xóa giao dịch này?",
      "deleteTransactionHistory": "Xoá lịch sử giao dịch?",
      "highValueLoss": "Tổn thất lớn",
      "insufficientGas": "Không đủ gas",
      "rateChanged": "Tỉ giá đã thay đổi",
      "resetSettings": "Đặt lại cài đặt?"
    }
  },
  "error": {
    "message": {
      "allowanceRequired": "Chuyển số lượng {{tokenSymbol}} vượt quá mức cho phép hiện tại của bạn. Vui lòng tăng mức độ cho phép sử dụng token và thử lại.",
      "insufficientFunds": "Bạn không có đủ gas để chi trả cho chi phí giao dịch.",
      "slippageThreshold": "Độ trượt giá lớn hơn ngưỡng xác định. Vui lòng yêu cầu một tuyến đường mới để nhận báo giá mới.",
      "transactionFailed": "Vui lòng kiểm tra block explorer để biết thêm thông tin.",
      "transactionNotSent": "Giao dịch chưa được gửi. {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} tại {{chainName}} vẫn còn trong ví của bạn.",
      "transactionRejected": "Cần có chữ ký để hoàn tất giao dịch. {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} tại {{chainName}} vẫn còn trong ví của bạn.",
      "unknown": "Vui lòng thử lại hoặc liên hệ hỗ trợ."
    },
    "title": {
      "allowanceRequired": "Sự cho phép không đủ",
      "balanceIsTooLow": "Số dư quá thấp",
      "chainSwitch": "Yêu cầu đổi chain",
      "gasLimitIsTooLow": "Giới hạn gas quá thấp",
      "insufficientFunds": "Không đủ tài sản",
      "slippageNotMet": "Điều kiện trượt giá không được đáp ứng",
      "transactionCanceled": "Giao dịch bị huỷ",
      "transactionFailed": "Giao dịch không thành công",
      "transactionRejected": "Yêu cầu chữ ký",
      "transactionUnderpriced": "Giao dịch bị định giá thấp",
      "transactionUnprepared": "Không thể tải giao dịch",
      "unknown": "Xảy ra lỗi",
      "walletAddressInvalid": "Địa chỉ ví không hợp lệ.",
      "walletAddressRequired": "Yêu cầu địa chỉ ví.",
      "walletEnsAddressInvalid": "Địa chỉ ví không hợp lệ hoặc mạng lưới không hỗ trợ ENS."
    }
  },
  "tooltip": {
    "additionalProviderFee": "Cầu bổ sung, DEX và phí dịch vụ.",
    "estimatedNetworkFee": "Phí mạng ước tính.",
    "estimatedTime": "Thời gian thực hiện lệnh swap (phút).",
    "notFound": {
      "text": "Chúng tôi không thể tìm thấy trang này.",
      "title": "404"
    },
    "numberOfSteps": "Một số bước swap. Mỗi bước có thể chứa 1-2 giao dịch yêu cầu chữ ký.",
    "progressToNextUpdate": "Thông tin hiển thị sẽ tự động làm mới sau {{value}} giây. Bấm vào đây để cập nhật thủ công.",
    "recommended": "Một tuyến đường giá rẻ cân bằng giữa sự phức tạp và dễ sử dụng.",
    "settingsModified": "Thiết lập (Đã điều chỉnh)"
  },
  "main": {
    "crossStepDetails": "Chuyển từ {{from}} đến {{to}} thông qua {{tool}}",
    "currentAmount": "Số lượng hiện tại",
    "estimatedTime": "{{value}}m",
    "featuredTokens": "Featured tokens",
    "from": "Từ",
    "fromAmount": "Yêu cầu",
    "gasCost": "Phí Gas",
    "gasFeeEstimated": "phí Gas ước tính",
    "gasFeePaid": "phí Gas đã trả",
    "inProgress": "đang xử lý",
    "nftStepDetails": "Mua NFT thông qua {{tool}}",
    "onChain": "tại {{chainName}}",
    "otherTokens": "Token khác",
    "ownedBy": "Được sở hữu bởi",
    "process": {
      "crossChain": {
        "actionRequired": "Vui lòng ký hoàn thành giao dịch",
        "done": "Giao dịch bridge đã được xác nhận",
        "pending": "Chờ giao dịch Bridge",
        "started": "Chuẩn bị giao dịch Bridge"
      },
      "nft": {
        "done": "NFT đã mua"
      },
      "receivingChain": {
        "done": "Bridge thành công",
        "partial": "Bridge thành công 1 phần",
        "pending": "Đạng chain đến",
        "refunded": "Giao dịch Bridge đã được hoàn trả"
      },
      "swap": {
        "actionRequired": "Vui lòng ký hoàn thành giao dịch",
        "done": "Lệnh swap đã hoàn tất",
        "pending": "Chờ giao dịch Swap",
        "started": "Đang chuẩn bị giao dịch Swap"
      },
      "switchChain": {
        "actionRequired": "Yêu cầu đổi chain",
        "done": "Chuyển đổi chain thành công"
      },
      "tokenAllowance": {
        "done": "Mã token đã được phê duyệt",
        "pending": "Chờ phê duyệt quyền sử dụng token",
        "started": "Thiết lập quyền sử dụng token"
      }
    },
    "quotedAmount": "Số tiền trích dẫn",
    "rateChange": "Thay đổi tỉ giá",
    "receiving": "Đang nhận",
    "refuelStepDetails": "Lấy gas thông qua {{tool}}",
    "selectChain": "Chọn chain",
    "selectChainAndToken": "Chọn chain và token",
    "selectToken": "Chọn Token",
    "sendToAddress": "Gửi đến {{address}}",
    "sendToWallet": "Gửi đến địa chỉ khác",
    "sending": "Đang gửi",
    "sentToAddress": "Gửi đến {{address}}",
    "stepBridge": "Cầu",
    "stepBridgeAndBuy": "Chuyển và mua",
    "stepDetails": "{{tool}} thông qua LI.FI",
    "stepSwap": "Swap",
    "stepSwapAndBridge": "Swap và Bridge",
    "stepSwapAndBuy": "Hoán đổi và mua",
    "supportId": "Mã ID yêu cầu hỗ trợ",
    "swapStepDetails": "Swap tại {{chain}} thông qua {{tool}}",
    "tags": {
      "cheapest": "Rẻ",
      "fastest": "Nhanh",
      "insurable": "Bảo hiểm",
      "insurance": "Bảo hiểm",
      "insured": "An toàn",
      "recommended": "Khuyến nghị",
      "safest": "An toàn"
    },
    "to": "Đến",
    "tokenOnChain": "{{tokenSymbol}} tại {{chainName}}",
    "tokenOnChainAmount": "{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} tại {{chainName}}",
    "tokenSearch": "Tìm kiếm bằng tên token hoặc địa chỉ",
    "valueLoss": "Bạn sẽ mất",
    "walletAddressOrEns": "Địa chỉ hoặc tên miền ENS"
  },
  "insurance": {
    "bridgeExploits": "Cầu trục trặc, bị hack hoặc bị khai thác",
    "insure": "Bảo hiểm <0>{{amount, number(maximumFractionDigits: 9)}}{{tokenSymbol}}</0> trong quá trình vận chuyển.",
    "insured": "Bạn đã bảo hiểm <0>{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}</0> trong quá trình vận chuyển:",
    "slippageError": "Lỗi trượt giá đối với token nhận được"
  },
  "settings": {
    "enabledBridges": "Số lượng cầu khả dụng",
    "enabledExchanges": "Số lượng sàn giao dịch khả dụng",
    "gasPrice": {
      "fast": "Nhanh",
      "normal": "Bình thường",
      "slow": "Chậm",
      "title": "Giá gas"
    },
    "routePriority": "Tuyền đường ưu tiên",
    "showDestinationWallet": "Hiển thị địa chỉ ví nhận",
    "slippage": "Trượt giá"
  },
  "wallet": {
    "extensionNotFound": "Chắc chắn rằng tiện ích trên trình duyệt {{name}} đã được kích hoạt tước khi chọn ví này."
  }
}
